export default 'Choose a color. Current color: ';